export default __webpack_public_path__ + "static/media/yellow-map-dot.2ae55f33.svg";